module.exports = __webpack_public_path__ + "static/img/图片1.e009720.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/图片1.png
// module id = 6g9e
// module chunks = 1